import {parse} from 'date-fns';
import {ptBR} from 'date-fns/locale';

export function parseDate(date?: string, formatDate: string = 'P') {
	if (!date) {
		return undefined;
	}
	return parse(date, formatDate, 0, {locale: ptBR});
}
